import { Button, Paper, Typography } from '@/ui';

interface PendingDebriefActionProps {
  debriefError?: string;
  isMarkingDebriefed: boolean;
  onMarkDebriefed?: () => void;
}

const PendingDebriefAction = ({
  debriefError,
  isMarkingDebriefed,
  onMarkDebriefed,
}: PendingDebriefActionProps) => (
  <Paper
    className="rounded-2xl border border-cement-200 bg-white p-4 shadow-md"
    data-testid="pending-debrief-action"
    elevation={0}
  >
    <Typography className="text-cement-400" variant="body2">
      Review these results with your member
    </Typography>
    <Button
      className="mt-3 w-full rounded-xl bg-sage-600 text-white hover:bg-sage-500"
      disabled={isMarkingDebriefed}
      variant="contained"
      onClick={onMarkDebriefed}
    >
      {isMarkingDebriefed ? 'Saving...' : 'Done'}
    </Button>
    {debriefError ? (
      <Typography className="mt-2 text-poppy-500" variant="caption">
        {debriefError}
      </Typography>
    ) : null}
  </Paper>
);

export type { PendingDebriefActionProps };
export default PendingDebriefAction;
